<template>
  <div>
    <DataTable
      title="Admin Requirment"
      @delete="deleteRecord"
      @create="createRecord"
      @edit_click="editRecord"
      :fields="fields"
      :response="response"
      :show_header_filter="false"
    />
  </div>
</template>
<script>
import { mapMutations } from 'vuex'

// imports
import DataTable from '@/components/DataTable.vue'

// exports
export default {
  name: 'AdminRequirments',
  components: {
    DataTable
  },
  data () {
    return {
      response: [],
      fields: [
        {
          name: 'Full Name',
          value: 'admin.full_name'
        },
        {
          name: 'daily sent',
          value: 'daily_sent'
        },
        {
          name: 'daily phone calls',
          value: 'daily_phone_calls'
        },
        {
          name: 'daily follow ups',
          value: 'daily_follow_ups'
        }
      ]
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    ...mapMutations('modals', ['create']),
    fetchData () {
      this.$network_utils
        .getAdminRequirments()
        .then((response) => {
          console.log(response)
          this.response = response
        })
    },
    deleteRecord (delete_data) {
      this.create({
        designator: 'delete-prompt',
        component_name: 'DeletePrompt',
        modal_title: 'Delete',
        item_name: delete_data.full_name,
        method: 'deleteAdminRequirment',
        method_params: { id: delete_data.id }
      })
    },
    createRecord () {
      this.create({
        designator: 'admin-list-form-modal',
        component_name: 'AdminRequirmentForm',
        is_create: true,
        modal_title: 'Create new Admin Requirment',
        props: {
          onRefresh: () => {
            this.fetchData()
          }
        }
      })
    },
    editRecord (data) {
      this.create({
        designator: 'admin-list-form-modal',
        component_name: 'AdminRequirmentForm',
        data,
        modal_title: 'Edit Admin Requirment',
        props: {
          onRefresh: () => {
            this.fetchData()
          }
        }
      })
    }
  }
}
</script>
